import { MenuEntryItem } from "@hermes/states/menu";

export const isMenuCategory = (menuEntry: MenuEntryItem) =>
    menuEntry.menuEntryList.length > 0;
